import React from 'react';
import I18n from 'i18n-js';
import { GearCollectionPill, GearCollectionPills } from './gear_collections/gear_collection_pill';
import { reverb_personalization_TrendingSearch } from '../schemas/rql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { COUNTRY_CODES } from '../shared/constants';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

interface IProps {
  onClick: Function;
  trendingSearches: reverb_personalization_TrendingSearch[];
}

export function shouldSkipTrendingSearches(ownProps) {
  if (ownProps.user.countryCode !== COUNTRY_CODES.US) { return true; }
  if (!isExperimentEnabled(ownProps.user, experiments.SEARCH_FORM_TRENDING_SEARCHES)) { return true; }
  return false;
}

export default function SearchFormTrendingSearches(props: IProps) {
  const trendingSearches = props.trendingSearches || [];
  if (!trendingSearches?.length) return null;

  const isAllSameCategory = trendingSearches.every(ts => ts.categoryUuid === trendingSearches[0].categoryUuid);

  const renderTrendingSearchesHeader = () => {
    if (isAllSameCategory) {
      return I18n.t('discovery.siteSearch.trendingSearches.trendingInHeader', { productCategory: productCategory(trendingSearches[0].categoryUuid) });
    } else {
      return I18n.t('discovery.siteSearch.trendingSearches.generalTrendingHeader');
    }
  };

  const renderTrendingSearchPill = (trendingSearch) => {
    return (
      <span className='collection-pill__text'>
        { isAllSameCategory ?
          <b>{trendingSearch.query}</b>
          :
          <span>
            <SanitizedRender
              html={
                I18n.t('discovery.siteSearch.trendingSearches.trendingInPill',
                  { query: trendingSearch.query,
                    productCategory: productCategory(trendingSearch.categoryUuid),
                    tagOpen: '<b>',
                    tagClose: '</b>',
                  },
                )
              }
            />
          </span>
        }
      </span>
    );
  };

  const productCategory = (uuid) => {
    return I18n.t(`discovery.taxonomy.${uuid}`);
  };

  return (
    <div className="site-search__dropdown__section">
      <div className="site-search__dropdown__section__heading">
        {renderTrendingSearchesHeader()}
      </div>
      <div className='trending-searches__container'>
        <GearCollectionPills>
          {trendingSearches.map((ts, index) =>
            <GearCollectionPill
              key={ts.query}
              handleAction={() => props.onClick(ts, (index + 1))}
            >
              {renderTrendingSearchPill(ts)}
            </GearCollectionPill>,
          )}
        </GearCollectionPills>
      </div>
    </div>
  );
}
